// Centralised data-testid registry for Thara Gold inventory app
export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
  logoutButton: "logout-button",
};

export const NAV = {
  dashboardLink: "nav-dashboard-link",
  syncMonitorLink: "nav-sync-monitor-link",
  stockMonitoringLink: "nav-stock-monitoring-link",
  productsLink: "nav-products-link",
  procurementLink: "nav-procurement-link",
  purchaseOrdersLink: "nav-purchase-orders-link",
  apiDocsLink: "nav-api-docs-link",
};

export const DASHBOARD = {
  container: "dashboard-container",
  kpiStockValue: "kpi-stock-value",
  kpiTotalProducts: "kpi-total-products",
  kpiLowStock: "kpi-low-stock",
  kpiBranchesSync: "kpi-branches-sync",
};

export const SYNC = {
  container: "sync-monitor-container",
  entityCard: (e) => `sync-entity-card-${e}`,
  triggerButton: (e) => `sync-trigger-${e}`,
  triggerFull: (e) => `sync-trigger-full-${e}`,
};

export const STOCK = {
  container: "stock-monitoring-container",
  tabOverall: "stock-tab-overall",
  tabBranchWise: "stock-tab-branchwise",
  tabLow: "stock-tab-low",
  tabDamaged: "stock-tab-damaged",
  tabFastMoving: "stock-tab-fast-moving",
  branchFilter: "stock-branch-filter",
  searchInput: "stock-search-input",
};

export const PRODUCT = {
  container: "products-container",
  searchInput: "product-search-input",
  categoryFilter: "product-category-filter",
  row: (id) => `product-row-${id}`,
  detail: "product-detail-container",
  uploadInput: "product-image-upload-input",
  uploadButton: "product-image-upload-button",
  deleteImage: (id) => `product-image-delete-${id}`,
};

export const PROCUREMENT = {
  container: "procurement-container",
  branchFilter: "procurement-branch-filter",
  selectAll: "procurement-select-all",
  rowCheckbox: (id) => `procurement-row-checkbox-${id}`,
  supplierSelect: (id) => `procurement-supplier-select-${id}`,
  createPoButton: "procurement-create-po-button",
};

export const PO = {
  container: "po-container",
  createButton: "po-create-button",
  submitButton: "po-submit-button",
  cancelButton: "po-cancel-button",
};
